import { FormField } from '@/types';
import React from 'react';

import { fields } from '@components/Form/FormFields';
import clsx from 'clsx';

type Props = {
  formFields: FormField[];
  errors: Record<string, string[]> | null;
};

const extractFieldsets = (formFields: FormField[]) => {
  const groupedFields = formFields.reduce<any>((prev, curr) => {
    if (!curr.fieldset) {
      return { ...prev, [curr.clean_name]: curr };
    }
    return {
      ...prev,
      [curr.fieldset]: {
        field_type: 'fieldset',
        legend: curr.fieldset,
        sort_order: Math.min(prev[curr.fieldset]?.sort_order ?? Infinity, curr.sort_order),
        fields: [...(prev[curr.fieldset]?.fields ?? []), curr],
      },
    };
  }, {});

  return Object.values<FormField>(groupedFields);
};

function FormFields(props: Props) {
  const { formFields, errors } = props;
  const formFieldsByFieldsets = extractFieldsets(
    formFields.sort((a, b) => a.sort_order - b.sort_order),
  );

  return (
    <>
      {formFieldsByFieldsets.map((field, index) => {
        const Component = fields[field.field_type];

        if (!Component) {
          return (
            <h2 key={field.id ?? `fieldset-${index}`}>
              Unknown form field <strong>{field.field_type}</strong>
            </h2>
          );
        }

        return (
          <div
            className={clsx('form-field', { 'form-field--error': errors?.[field.clean_name] })}
            key={field.id}
            style={field.width ? { width: `${field.width}%` } : {}}
          >
            <Component key={field.id ?? `fieldset-${index}`} {...field} />
            {errors?.[field.clean_name] ? (
              <div className='form-field__error-message'>
                {errors[field.clean_name].map(error => (
                  <div key={error} dangerouslySetInnerHTML={{ __html: error }} />
                ))}
              </div>
            ) : null}
          </div>
        );
      })}
    </>
  );
}

export default FormFields;
